import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useTheme } from "@mui/system";
import { Box } from "@mui/material";
import { Tab } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import GenericDashboard from "../../../../components/genericDashboard";
import FortigateVpnPanel from "./vpnPanel";
import LicencasPanel from "./licencasPanel";
import NoHostScreen from "../noHostScreen";
import useStyles from "./styles";

const ABAS = ["VPNs", "WAN", "HA", "Licenças"];

// Textos pré-quebrados: são desenhados dentro do SVG da ilustração, que não
// quebra linha sozinho (máx. ~28 caracteres por linha)
const SEM_DADOS_WAN = `Este equipamento não possui\ncoleta de WAN configurada.`;
const SEM_DADOS_HA = `Este equipamento não possui\ncoleta de alta\ndisponibilidade configurada.`;

export default function DashFortigate() {
  const outletProps = useOutletContext();
  const [aba, setAba] = useState(0);
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={styles.contentContainer}>
      <TabContext value={aba}>
        <TabList onChange={(_, v) => setAba(v)}>
          {ABAS.map((label, i) => (
            <Tab key={label} label={label} value={i} />
          ))}
        </TabList>
      </TabContext>

      {/* Aba VPNs — painel customizado de VPNs */}
      {aba === 0 && <FortigateVpnPanel />}

      {/* Aba WAN — itens WAN/SD-WAN via schema (group: "wan") */}
      {aba === 1 && (
        <GenericDashboard
          {...outletProps}
          api={outletProps.api}
          dash="firewall"
          group="wan"
          semDadosSlot={<NoHostScreen mensagem={SEM_DADOS_WAN} />}
        />
      )}

      {/* Aba HA — itens de Alta Disponibilidade via schema (group: "ha") */}
      {aba === 2 && (
        <GenericDashboard
          {...outletProps}
          api={outletProps.api}
          dash="firewall"
          group="ha"
          semDadosSlot={<NoHostScreen mensagem={SEM_DADOS_HA} />}
        />
      )}

      {/* Aba Licenças — painel customizado de Licenças */}
      {aba === 3 && <LicencasPanel />}
    </Box>
  );
}
